<template>
  <div class="bj_show">

    <div class="container-fluid container-fluid-a">
      <div class="row-fluid">
        <!--最新活动-->
        <div class="span12 text-left">
          <div class="jumbotron" style="padding-top:20px;">
            <div class="container">
              <div class="row">
                <div class="col-12" style="padding: 0px;">
                  <img :src=list.imgages_a width="100%" />
                </div>
              </div>
            </div>
            <div class="tt_20">服务社区：
              <span class="label label-primary label_50" style="padding-top:4px">关爱儿童</span>
              <span class="label label-primary label_50" style="padding-top:4px">未来发展</span>
            </div>
            <!-- <i class="iconfont i1" v-if="icon" @click.stop="iconbtn()">&#xe771;</i>
            <i class="iconfont ic1" v-else @click.stop="iconbtn()">&#xe629;</i> -->
            <div class="tt_10">筹款金额：{{list.fabulous}}元</div>
            <div class="progress" style="margin-bottom:0px; margin-top:0.8rem;height: 15px;">
              <div class="progress-bar" role="progressbar" :aria-valuenow=list.browse aria-valuemin="0"
                aria-valuemax="100" :style="{width: list.browse + '%' }">
                {{list.browse}}%
              </div>
            </div>

          </div>

          <div>
            <h4>项目介绍</h4>
            <div class="row">
              <div class="col-12" style="text-indent:2.2em;">
                {{list.detailed}}
              </div>
            </div>
          </div>
          <div class="tt_10 tt_x_10">
            <h4>捐赠信息</h4>
          </div>
          <div class="row">
            <div class="col-12 col-12-12">
              <div class="jumbotron  text-left" style="padding: 15px 10px; line-height:2.5rem" v-html="list.imgages_3">
                <!-- {{list.imgages_3}} -->
                <!-- 中华慈善总会接收资金捐赠热线电话：<br />
                010-66055848<br />
                010-66083264<br /> -->
              </div>
            </div>
          </div>

        </div>

      </div>
      <div id="d_p_80"></div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      icon: true,
      list: [],
      id: ''
    }
  },
  components: {},
  props: {},
  created () { },
  mounted () {
    // http://dns1.hsnms.com:17074/app/data/info/id的值?appid=202108&type_id=8001
    this.$api.getAPI("data/info/" + this.$route.query.id + "?appid=202108&type_id=8001&state=1", {}).then(
      res => {
        console.log(res.data.data.models);
        this.list = res.data.data.models;
        this.id = res.data.data.models.db_id;
      })
    //查询是否关注
    console.log(this.$api.getUserInfo().openid);
    //"2021085001zswd999961"
    // var g_id = "2021085001" + this.$api.getUserInfo().openid + this.$route.query.id;
    //console.log(g_id);
    this.$api.getAPI('mutual/click/?appid=202108&type_id=5001&state=1', {
      openid: this.$api.getUserInfo().openid,
      db_id: this.id
    }).then(res => {
      console.log(res);
    })

    // console.log(this.$route.query.id);
  },
  methods: {
    // iconbtn () {
    //   if (this.icon == false) {
    //     this.$axios.get('app/mutual/click/?appid=202108&type_id=5001&state=1', {
    //       params: {
    //         openid: window.localStorage.getItem('openid')
    //       }
    //     }).then(res => {
    //       console.log(res.data.data[0].models);
    //       for (let i = 0; i < res.data.data[0].models.length; i++) {
    //         // console.log(res.data.data[0].models[i].connect == window.location.href);
    //         if (res.data.data[0].models[i].key_value == '2' + '202108' + '5001' + window.localStorage.getItem(
    //           'openid') + this.$route.query.id && res.data.data[0].models[i].state == 1) {
    //           // this.icon = false
    //           // console.log(this.icon);
    //           this.id = res.data.data[0].models[i].id
    //           console.log(this.id);
    //           this.$axios.get('app/mutual/click/' + this.id + '?appid=202108&type_id=5001&state=1', {
    //             params: {
    //               openid: window.localStorage.getItem('openid')
    //             }
    //           }).then(res => {
    //             console.log(res.data);
    //             let data = new FormData()
    //             data.append('state', 2)
    //             data.append('openid', window.localStorage.getItem('openid'))
    //             this.$axios({
    //               method: "POST",
    //               // http://dns1.hsnms.com:17074/app/mutual/click/id的值?appid=202108&type_id=5001&openid=用户id
    //               url: "app/mutual/click/" + this.id + "?appid=202108&type_id=5001&state=1",
    //               data: data,
    //             }).then(res => {
    //               console.log(res);
    //             })
    //           })
    //         }
    //       }
    //     })

    //   } else {
    //     let data = new FormData()
    //     data.append('openid', window.localStorage.getItem('openid'))
    //     data.append('key_value', '2' + '202108' + '5001' + window.localStorage.getItem('openid') + this.$route.query
    //       .id)
    //     data.append('key_name', this.list.describe)
    //     data.append('key_img', this.list.imgages_a)
    //     data.append('connect', window.location.hash)
    //     data.append('state', 1)
    //     // console.log(this.title, this.img, window.location.href);
    //     // http://dns1.hsnms.com:17074/app/mutual/click/?appid=202108&type_id=5001
    //     this.$axios({
    //       method: "POST",
    //       url: "app/mutual/click/?appid=202108&type_id=5001&state=1",
    //       data: data,
    //     }).then(res => {
    //       console.log(res);
    //     })
    //   }
    //   this.icon = !this.icon
    // }



  }
}
</script>

<style>
.i1 {
  position: absolute;
  right: 30px;
  top: 270px;
  font-size: 25px !important;
}

.ic1 {
  position: absolute;
  right: 30px;
  top: 274px;
  font-size: 18px !important;
  color: #ffd986;
}

.bj_show {
  background: #01b2c2;
  height: 12rem;
}

.container-fluid-a {
  position: absolute;
  top: 20px;
}

.jumbotron {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/charitable_show.vue